export const ENABLE_FULL_ACCESS_CONFIG_KEY = 'enableFullAccess';

export const readEnableFullAccess = (configs: Map<string, string>): boolean => {
  const raw = configs.get(ENABLE_FULL_ACCESS_CONFIG_KEY);
  if (raw == null || raw.trim() === '') {
    return false;
  }
  return raw.trim().toLowerCase() === 'true';
};
